import React, { Component } from 'react';
import { FormModalContainer, FormModalContent, FinishButton } from './style';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { TextArea } from '../../Inputs/CreateEditInput/TextArea';

export class AddWorkoutDescriptionModal extends Component {
    state = {
        workoutDescription: this.props.description || '',
    };

    handleDescriptionChange = ({ target: { value: workoutDescription } }) => {
        this.setState({ workoutDescription });
    };

    addDescription = description => {
        const { onDescriptionSet, onClose } = this.props;
        onDescriptionSet(description);
        onClose();
    };

    render() {
        const {
            state: { workoutDescription },
            props: { onClose },
            handleDescriptionChange,
            addDescription,
        } = this;

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        Add workout description
                    </Text>

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <div style={{ width: '100%', marginBottom: '20px' }}>
                        <TextArea
                            label={'Description'}
                            placeholder={
                                'Enter short description af your workout here. Any tips for yourself or other users?'
                            }
                            value={workoutDescription}
                            onChange={handleDescriptionChange}
                            width={'100%'}
                        />
                    </div>

                    <div style={{ width: '100%' }}>
                        <FinishButton onClick={addDescription.bind(this, workoutDescription)}>Finish</FinishButton>
                    </div>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutDescriptionModal/index.js